import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateRoleInput, RoleResponse, UpdateRoleInput } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useRolesQuery() {
  return useQuery({ queryKey: ['admin-roles'], queryFn: () => api.get<RoleResponse[]>('/admin/roles') });
}

export function useCreateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateRoleInput) => api.post<RoleResponse>('/admin/roles', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-roles'] }),
  });
}

export function useUpdateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateRoleInput }) => api.patch<RoleResponse>(`/admin/roles/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-roles'] }),
  });
}

export function useResetRoleToTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<RoleResponse>(`/admin/roles/${id}/reset-to-template`, {}),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-roles'] }),
  });
}
